<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content style="white-space: pre-wrap;">{{data.text}}</div>
<div mat-dialog-actions align="center">
  @if(!data.showConfirmOnly) {
  <button mat-button mat-dialog-close>Abbrechen</button>
  }
  <button mat-button [mat-dialog-close]="true">Ok</button>
</div>
